import dayjs from "dayjs";

export const DATE_FORMAT = "YYYY-MM-DD";

export function defaultGamification() {
    return {
        posts: {
            with_photo: { points: 1000, daily_limit: 3 },
            only_text: { points: 20, daily_limit: 1 },
        },
        activity: { points: 1500, daily_limit: 2 },
        interactions: { like: 1, comment: 2 },
    };
}

export function defaultInterval() {
    const today = dayjs();
    return {
        start_date: today.format(DATE_FORMAT),
        end_date: today.add(21, "day").format(DATE_FORMAT),
    };
}

export function isFilledLink(link) {
    return !!(link?.title?.trim() || link?.url?.trim());
}

export function isValidHttpUrl(str) {
    if (!str?.trim()) return false;
    try {
        const u = new URL(str.trim());
        return u.protocol === "http:" || u.protocol === "https:";
    } catch {
        return false;
    }
}

export function validateConfig(cfg) {
    const errors = {};
    let valid = true;

    if (!cfg?.name?.trim()) {
        errors.name = "Insira o nome do grupo";
        valid = false;
    }

    if (Array.isArray(cfg?.plans) && cfg.plans.length === 0) {
        errors.plans = "Selecione ao menos um plano";
        valid = false;
    }

    const links = cfg?.links || [];
    const linkErrors = {};
    links.forEach((link, i) => {
        if (!isFilledLink(link)) return;
        const e = {};
        if (!link?.title?.trim()) e.title = "Informe o título do link";
        if (!link?.url?.trim()) {
            e.url = "Informe a URL do link";
        } else if (!isValidHttpUrl(link.url)) {
            e.url = "URL inválida";
        }
        if (Object.keys(e).length > 0) {
            linkErrors[i] = e;
            valid = false;
        }
    });
    if (Object.keys(linkErrors).length > 0) errors.links = linkErrors;

    if (cfg?.type === "CHALLENGE") {
        const start = cfg?.interval?.start_date
            ? dayjs(cfg.interval.start_date)
            : null;
        const end = cfg?.interval?.end_date
            ? dayjs(cfg.interval.end_date)
            : null;

        if (!start?.isValid()) {
            errors.startDate = "Selecione a data de início";
            valid = false;
        } else if (start.startOf("day").isBefore(dayjs().startOf("day"))) {
            errors.startDate = "A data de início deve ser hoje ou no futuro";
            valid = false;
        }
        if (!end?.isValid() || (start?.isValid() && !end.isAfter(start))) {
            errors.endDate = "A duração do desafio é inválida";
            valid = false;
        }

        const g = cfg?.gamification;
        if (
            !g ||
            !g.posts?.with_photo ||
            !g.posts?.only_text ||
            !g.activity ||
            !g.interactions
        ) {
            errors.gamification = "Configure as regras de pontuação";
            valid = false;
        }

        const awards = cfg?.awards || [];
        const awardErrors = {};
        awards.forEach((award, i) => {
            const e = {};
            if (!award?.title?.trim()) e.title = "Informe o título";
            if (Object.keys(e).length > 0) {
                awardErrors[i] = e;
                valid = false;
            }
        });
        if (Object.keys(awardErrors).length > 0) errors.awards = awardErrors;
    }

    return { isValid: valid, errors };
}

export function clearErrorPath(errors, path) {
    if (!errors || Object.keys(errors).length === 0) return errors;
    const segments = path.split(".");
    const next = { ...errors };
    let cursor = next;
    for (let i = 0; i < segments.length - 1; i++) {
        const k = segments[i];
        if (cursor[k] === undefined) return errors;
        cursor[k] = Array.isArray(cursor[k]) ? [...cursor[k]] : { ...cursor[k] };
        cursor = cursor[k];
    }
    const leaf = segments[segments.length - 1];
    if (cursor[leaf] === undefined) return errors;
    delete cursor[leaf];
    return next;
}
